import * as React from "react"

export const ExternalLinkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.756 16.584q-.563 0-.95-.389a1.3 1.3 0 0 1-.39-.951V4.757q0-.562.39-.951.387-.39.95-.389h4.382a.527.527 0 0 1 .541.537.53.53 0 0 1-.155.388.52.52 0 0 1-.386.158H4.756a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.177v10.487q0 .096.08.176t.176.08h10.488a.24.24 0 0 0 .176-.08.24.24 0 0 0 .08-.176v-4.381a.527.527 0 0 1 .537-.542q.23 0 .388.155a.52.52 0 0 1 .158.387v4.38q0 .564-.388.952a1.3 1.3 0 0 1-.951.389zM15.5 5.274 8.455 12.32a.5.5 0 0 1-.372.167.57.57 0 0 1-.381-.187.54.54 0 0 1-.181-.388q0-.206.18-.387L14.727 4.5h-2.184A.527.527 0 0 1 12 3.963q0-.229.156-.387a.52.52 0 0 1 .386-.159h3.371q.288 0 .479.192a.65.65 0 0 1 .191.478v3.372a.526.526 0 0 1-.537.541.53.53 0 0 1-.387-.155.52.52 0 0 1-.159-.386z"
    ></path>
  </svg>
)
